//import App from './app';
import AppContainer from './app-container';

export default AppContainer;
